import { ListUploadFilesResponse } from '@types'
import { CancelTokenSource, Service } from '@tino-frontend/adapters'
import { legalEntityFilesTransform } from 'services/transformers'

export class PowerOfAttorneyService {
  constructor(
    private readonly http: Service,
    // @ts-expect-error no unused vars
    private readonly _storage: Service
  ) {}

  rejectPowerOfAttorneyDocument(
    legalPersonId: string,
    fileId: string
  ): Promise<unknown> {
    return this.http.patch(
      `/onboarding/legal-person/${legalPersonId}/power-of-attorney/files/${fileId}/reject`
    )
  }

  downloadPowerOfAttorneyDocumentURLRequest(
    legalPersonId: string,
    fileId: string
  ): Promise<unknown> {
    return this.http.patch(
      `/onboarding/legal-person/${legalPersonId}/power-of-attorney/files/${fileId}/download`
    )
  }

  async uploadPowerOfAttorneyDocument(
    legalPersonId: string,
    files: File[]
  ): Promise<unknown> {
    try {
      for (const file of files) {
        const { url } = await this.http.get<unknown, { url: string }>(
          `/onboarding/legal-person/${legalPersonId}/power-of-attorney/file/upload`
        )

        await this.http.put(url, file)

        await this.http.post(
          `/onboarding/legal-person/${legalPersonId}/power-of-attorney/file/upload`,
          {
            filename: file.name,
            legal_person_id: legalPersonId,
          }
        )
      }

      return this.http.post(
        `/onboarding/legal-person/${legalPersonId}/power-of-attorney`
      )
    } catch (e) {
      return Promise.reject(e)
    }
  }

  retryPowerOfAttorneyDocument(legalPersonId: string): Promise<unknown> {
    return this.http.patch(
      `/admin/onboarding/legal-person/${legalPersonId}/power-of-attorney/retry`
    )
  }

  approvePowerOfAttorneyDocument(
    legalPersonId: string,
    fileId: string
  ): Promise<unknown> {
    return this.http.post(
      `/admin/onboarding/legal-person/${legalPersonId}/power-of-attorney/${fileId}/approve`
    )
  }

  finishUploadPowerOfAttorneyDocument(legalPersonId: string): Promise<unknown> {
    return this.http.post(
      `/onboarding/legal-person/${legalPersonId}/power-of-attorney`
    )
  }

  skipUploadPowerOfAttorneyDocument(
    legalPersonId: string
  ): Promise<ListUploadFilesResponse> {
    return this.http.post(
      `/onboarding/legal-person/${legalPersonId}/power-of-attorney/skip`
    )
  }

  async getPowerOfAttorneyDocumentFiles(
    legalPersonId: string
  ): Promise<ListUploadFilesResponse> {
    try {
      const response = await this.http.get<unknown, ListUploadFilesResponse>(
        `/onboarding/legal-person/${legalPersonId}/power-of-attorney/files`
      )
      return legalEntityFilesTransform(response)
    } catch (e) {
      return Promise.reject(e)
    }
  }

  getCancelSource(): CancelTokenSource {
    return this.http.generateCancelRef()
  }
}
